export enum PlatformsEnum {
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
  TELEGRAM = 'telegram',
}
